function loadJSON(filePath) {
    const json = loadTextFileAjaxSync(filePath, "application/json");
    return JSON.parse(json);
}

function loadTextFileAjaxSync(filePath, mimeType) {
    const xmlhttp = new XMLHttpRequest();
    xmlhttp.open("GET", filePath, false);
    if (mimeType != null) {
        if (xmlhttp.overrideMimeType) {
            xmlhttp.overrideMimeType(mimeType);
        }
    }
    xmlhttp.send();
    if (xmlhttp.status == 200) {
        return xmlhttp.responseText;
    }
    else {
        return null;
    }
}

window.userLang = navigator.language || navigator.userLanguage;
let language = window.userLang.split("-")[0];
export const data = loadJSON('locales/'+language+'/translation.json');